import { classesBuilder } from '@common/helpers';
import Icon from '@components/Icon';

import style from '@components/StarRating/styles.module.scss';

const StarButton = ({
  value,
  rating,
  readOnly,
  onRate,
}: {
  value: number;
  rating: number;
  readOnly: boolean;
  onRate: (value: number) => void;
}) => {
  return (
    <button
      type="button"
      key={value}
      aria-checked={rating === value}
      tabIndex={readOnly ? -1 : 0}
      onClick={() => {
        return onRate(value);
      }}
      className={classesBuilder(style.star, {
        [style.filled]: value <= rating,
        [style.readOnly]: readOnly,
      })}
      disabled={readOnly}
    >
      <Icon
        name="star"
        size={24}
      />
    </button>
  );
};

export default StarButton;
